// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__gkpKo","ranges":"BmiRanges_ranges__Hz2in"};